module.exports = {
    RECEIVE_ALL_SECTOR: 'RECEIVE_ALL_SECTOR',
    RECEIVE_SECTOR: 'RECEIVE_SECTOR',
    RECEIVE_SECTORS: 'RECEIVE_SECTORS',
    RESET_SECTOR: 'RESET_SECTOR',
    RECEIVE_SECTOR_QUALITOMETERS: 'RECEIVE_SECTOR_QUALITOMETERS',
}
